import ChartNivAcuteDiepeVeneuzeTrombose from "../../../../src/client/niv_acuteboekje/json/diepe-veneuze-trombose.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivAcuteDiepeVeneuzeTrombose,
  ChartNivSchematic,
  React
};